// Module
var code = "<div class=\"block-9__intro\"> <p class=\"block-9__intro__title p4 neumatic uppercase huge-text\"></p> <div class=\"block-9__intro__text text\"></div> </div> <div class=\"block-9__content\"> <div class=\"image\"></div> <div class=\"block-9__content__image-caption\"> <div class=\"text\"></div> <div class=\"credits\"></div> </div> </div> ";
// Exports
export default code;